import { styled, keyframes } from 'styled-components';

const keyFramesLoader = keyframes`
    33%{background-size:calc(100%/3) 0%  ,calc(100%/3) 100%,calc(100%/3) 100%}
    50%{background-size:calc(100%/3) 100%,calc(100%/3) 0%  ,calc(100%/3) 100%}
    66%{background-size:calc(100%/3) 100%,calc(100%/3) 100%,calc(100%/3) 0% }
`

export const DivCardContainer = styled.div`
    width: 350px;
    height: max-content;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    background: ${(props) => props.theme.surface};
    border: 1px solid ${(props) => props.theme.border};
    box-shadow: ${(props) => props.theme.shadowSm};
    border-radius: ${(props) => props.theme.radius.md};
    padding: 1rem;
    transition: transform .2s, box-shadow .2s;
    cursor: pointer;
    &:hover {
        transform: translateY(-2px);
        box-shadow: ${(props) => props.theme.shadowMd};
    };
    & .title {
        font-size: ${(props) => props.theme.type.cardTitle};
        font-weight: 700;
        text-align: center;
    };
    & .data {
        font-size: 1rem;
        margin: auto;
        font-variant-numeric: tabular-nums;
    };
    & .red {
        color: ${(props) => props.theme.danger};
    };
    & .green {
        color: ${(props) => props.theme.ok};
    }
`

export const DivLoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`

export const DivLoaderChild = styled.div`
    width: 40px;
    aspect-ratio: 4;
    --_g: no-repeat radial-gradient(circle closest-side,${(props) => props.theme.accent} 90%,#0000);
    background: 
      var(--_g) 0%   50%,
      var(--_g) 50%  50%,
      var(--_g) 100% 50%;
    background-size: calc(100%/3) 100%;
    animation: l7 1s infinite linear;
    animation-name: ${keyFramesLoader};
`
